// @flow

export const PRICE_REG_EXP: RegExp = /^(\d+)\.(\d{2})$/
